import { render } from "./FeaturedResultsPanel.vue?vue&type=template&id=b9a8c030&scoped=true"
import script from "./FeaturedResultsPanel.vue?vue&type=script&lang=js"
export * from "./FeaturedResultsPanel.vue?vue&type=script&lang=js"

import "./FeaturedResultsPanel.vue?vue&type=style&index=0&id=b9a8c030&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a8c030"]])

export default __exports__